import Logo from '@app/icare/assets/logo-green.svg?inline'
import { signInWithMicrosoft } from '@app/icare/client/auth/auth'
import { DevSignIn } from '@app/icare/components/auth/DevSignIn'
import { Trans } from '@lingui/react/macro'
import { version } from '@pkg/shared/env'
import { useSearch } from '@tanstack/react-router'
import { Alert, Button, Divider } from 'antd'
import { FaMicrosoft } from 'react-icons/fa6'

export function Login() {
  const search = useSearch({ strict: false }) as { error?: string; next?: string }
  const { error, next } = search

  return (
    <div data-testid="login" className="mx-auto min-h-screen w-full bg-gray-100 sm:px-4 md:px-0">
      <div className="sm:mx-auto sm:w-full lg:max-w-7xl">
        <div className="px-4 py-8 sm:rounded-lg sm:px-10">
          <div className="pb-96 sm:mx-auto sm:w-full sm:max-w-xl">
            <div className="md:mt-16 space-y-4 rounded-lg bg-white px-4 py-8 shadow-lg ring-1 ring-black/5 sm:px-10">
              <div className="flex justify-center">
                <img src={Logo} alt="confido-care" height={48} />
              </div>
              <div>
                <h3 className="my-2 text-center">
                  <Trans>Bei iCare anmelden</Trans>
                </h3>
              </div>
              {error && (
                <Alert
                  type="error"
                  showIcon
                  data-testid="error-alert"
                  title={<Trans>Anmeldung fehlgeschlagen</Trans>}
                  description={error}
                />
              )}
              <Button
                type="primary"
                block
                size="large"
                icon={<FaMicrosoft />}
                data-testid="signin-microsoft"
                onClick={() => signInWithMicrosoft(next)}
              >
                <Trans>Mit Microsoft anmelden</Trans>
              </Button>
              <Divider className="my-0" />
              <DevSignIn />
              <div className="mt-auto pt-4 text-center">
                <span className="text-sm italic">
                  <Trans>Version:</Trans> {version}
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
